module.exports = __webpack_public_path__ + "static/media/MediaIcon.c864379f.svg";